<template>
  <div
    class="gw_btn weight_500 text-medium"
    tour="btnupload"
    @click.stop="handleClick()"
  >
    <i class="mdi-upload mdi mr-1"></i>
    {{ $t('btn.upload') }}
  </div>
</template>

<script>
export default {
  name: 'UploadBtn',
  methods: {
    handleClick() {
      this.$store.dispatch('globals_drawer_toggle')
    },
  },
}
</script>
